import { render, staticRenderFns } from "./widget_best_portfolio.vue?vue&type=template&id=43709d88&scoped=true&"
import script from "./widget_best_portfolio.vue?vue&type=script&lang=js&"
export * from "./widget_best_portfolio.vue?vue&type=script&lang=js&"
import style0 from "./widget_best_portfolio.vue?vue&type=style&index=0&id=43709d88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43709d88",
  null
  
)

export default component.exports